export const PlannerFormModel = {
    formId: 'plannerForm',
    formField: {
        cargo: {
            name: 'cargo',
            label: 'Cargo',
            requiredErrorMsg: 'El cargo es requerido'
        },
        turnos: {
            name: 'turnos',
            label: 'Turnos',
            requiredErrorMsg: 'Debe seleccionar al menos un turno'
        },
        cantidad: {
            name: 'cantidad',
            label: 'Cantidad requerida',
            requiredErrorMsg: 'La cantidad es requerida'
        },
        repeticion: {
            name: 'repeticion',
            label: 'Repetición',
            requiredErrorMsg: 'La repetición es requerida'
        },
        diasSemana: {
            name: 'diasSemana',
            label: 'Días de la semana',
        }
    }
};
